import React from "react";
import { Group, Text, Menu } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

export default function FilterSort({ options = [], value, onChange }) {
  if (!options.length) return null;

  return (
    <Group position="apart" mb="xs">
      <Text size="sm" mb={4}>
        Sort
      </Text>
      <Menu
        withinPortal={false}
        control={
          <Group spacing={4} style={{ cursor: "pointer" }}>
            <Text size="xs" color="grey" style={{ textTransform: "capitalize" }}>
              {value}
            </Text>
            <FontAwesomeIcon icon={solid("chevron-right")} size="xs" color="grey" />
          </Group>
        }
      >
        {options.map((item, key) => (
          <Menu.Item
            key={key}
            rightSection={item.value === value ? <FontAwesomeIcon icon={solid("check")} size="xs" /> : undefined}
            onClick={() => onChange(item.value)}
          >
            {item.label}
          </Menu.Item>
        ))}
      </Menu>
    </Group>
  );
}